import { createFileRoute } from "@tanstack/react-router";
import { alternatePath } from "@/lib/i18n";
import { buildHead, breadcrumbJsonLd, faqJsonLd, serviceJsonLd } from "@/lib/seo";
import { FAQS_SHOPIFY_TECH_SEO } from "@/lib/service-content/faqs/shopify-tech-seo";

const PATH = "/es/seo-tecnico-shopify";

export const Route = createFileRoute("/es/seo-tecnico-shopify")({
  head: () => buildHead({
    locale: "es",
    title: "Agencia SEO Shopify en México | SEO Técnico · Shugert",
    description: "SEO técnico Shopify para México: rastreo, indexación, canonicals, schema, arquitectura, facetas, Core Web Vitals y continuidad SEO en migraciones con implementación senior.",
    path: PATH,
    altPath: alternatePath(PATH, "en"),
    ogImage: "/og-default-v2.jpg",
    jsonLd: [
      breadcrumbJsonLd([{ name: "Inicio", path: "/es" }, { name: "SEO Shopify en México", path: PATH }]),
      faqJsonLd(FAQS_SHOPIFY_TECH_SEO.es),
      serviceJsonLd({
        name: "Agencia de SEO Técnico Shopify en México",
        description: "SEO técnico Shopify para catálogos en México y Latinoamérica ligado a ownership de URLs, rastreo, indexación, canonicals, schema, arquitectura, Core Web Vitals y mapas de redirects.",
        path: PATH,
        serviceType: "Agencia de SEO Técnico Shopify",
        minPrice: 3000,
        maxPrice: 5000,
        unit: "PROJECT",
        deliverables: ["Mapa de arquitectura de búsqueda", "Diagnóstico de indexación", "Implementación priorizada", "Cambios técnicos en staging", "Validación en Search Console"],
        locale: "es",
      }),
    ],
  }),
});
